import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CheckCircle2, BookOpen } from 'lucide-react';
import { trackButtonClick } from '../utils/pixel';
const books = [{
  tomo: 'Tomo 1',
  title: 'El Código de la Calma',
  description: 'Entendé por qué tu hijo hace berrinches. No te está manipulando, su cerebro inmaduro literalmente no puede regularse solo. Descubrí qué pasa en su cabeza durante una explosión.',
  checklist: ['Desarrollo cerebral de 2 a 5 años', 'Por qué los berrinches son normales', 'El mito de la manipulación infantil'],
  color: 'text-sage',
  bg: 'bg-sage/10'
}, {
  tomo: 'Tomo 2',
  title: 'El Radar de Prevención',
  description: 'El mejor berrinche es el que no ocurre. Aprendé a identificar los detonantes antes de que exploten y creá un entorno que reduzca las crisis diarias en un 80%.',
  checklist: ['Identificación de detonantes comunes', 'Rutinas que dan seguridad', 'Cómo anticipar transiciones difíciles'],
  color: 'text-terracotta',
  bg: 'bg-terracotta/10'
}, {
  tomo: 'Tomo 3',
  title: 'Protocolo 0-90 Segundos',
  description: 'El protocolo exacto de 90 segundos para cuando el berrinche ya estalló. Qué hacer, qué decir y cómo mantener la calma cuando tu hijo pierde el control total.',
  checklist: ['Protocolo de 3 pasos para la crisis', 'Guiones exactos de qué decir', 'Cómo mantener tu propia calma'],
  color: 'text-dark-green',
  bg: 'bg-dark-green/10'
}, {
  tomo: 'Tomo 4',
  title: 'El Puente de Reconexión',
  description: 'Qué hacer después de que pasó la tormenta. Cómo reconectar, reparar el vínculo si perdiste la paciencia, y enseñarles a identificar sus emociones para la próxima vez.',
  checklist: ['La importancia de la reparación', 'Cómo pedir perdón sin perder autoridad', 'Enseñando vocabulario emocional'],
  color: 'text-sage',
  bg: 'bg-sage/10'
}, {
  tomo: 'Tomo 5',
  title: 'Límites Claros y Firmes',
  description: "Cómo decir 'no' sin generar una guerra mundial. Establecé límites que se respeten desde el amor y la firmeza, terminando con la lucha de poder constante.",
  checklist: ['Diferencia entre límite y castigo', "Cómo sostener un 'no'", 'Consecuencias lógicas vs. punitivas'],
  color: 'text-terracotta',
  bg: 'bg-terracotta/10'
}, {
  tomo: 'Tomo 6',
  title: 'El Ancla del Adulto',
  description: 'No podés calmar a tu hijo si vos estás desbordada. Estrategias reales y posibles para mamás sin tiempo que necesitan recargar su propia paciencia.',
  checklist: ['Micro-momentos de regulación', 'Gestión de la culpa materna', 'Red de apoyo y expectativas reales'],
  color: 'text-dark-green',
  bg: 'bg-dark-green/10'
}];
export function BooksGrid() {
  const handleCTAClick = () => {
    trackButtonClick('BooksGrid CTA - Quiero este sistema completo');
  };
  return <section className="py-20 md:py-28 bg-white" data-id="element-43">
      <div className="container mx-auto px-4" data-id="element-44">
        <SectionWrapper data-id="element-45">
          <div className="text-center mb-16" data-id="element-46">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-playfair font-bold text-dark-green mb-4" data-id="element-47">
              Los 6 ebooks que forman el sistema
            </h2>
          </div>
        </SectionWrapper>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto" data-id="element-48">
          {books.map((book, index) => <SectionWrapper key={index} delay={0.1 * index} data-id="element-49">
              <div className="bg-offwhite border border-sage/20 rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow group h-full flex flex-col" data-id="element-50">
                <div className="flex items-center gap-4 mb-6" data-id="element-51">
                  <div className={`w-14 h-14 rounded-xl ${book.bg} ${book.color} flex items-center justify-center group-hover:scale-110 transition-transform`} data-id="element-52">
                    <BookOpen size={28} data-id="element-53" />
                  </div>
                  <div data-id="element-54">
                    <span className={`font-poppins font-bold text-sm uppercase tracking-wider ${book.color}`} data-id="element-55">
                      {book.tomo}
                    </span>
                    <h3 className="font-playfair text-2xl font-bold text-dark-green leading-tight mt-1" data-id="element-56">
                      {book.title}
                    </h3>
                  </div>
                </div>

                <p className="font-poppins text-base text-dark-green/80 leading-relaxed mb-8 flex-grow" data-id="element-57">
                  {book.description}
                </p>

                <div className="pt-6 border-t border-sage/10" data-id="element-58">
                  <ul className="space-y-3" data-id="element-59">
                    {book.checklist.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-sm md:text-base text-dark-green/90 font-poppins font-medium" data-id="element-60">
                        <CheckCircle2 className={`w-5 h-5 ${book.color} mt-0.5 flex-shrink-0`} data-id="element-61" />
                        <span data-id="element-62">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </SectionWrapper>)}
        </div>

        <SectionWrapper delay={0.4} data-id="element-63">
          <div className="mt-20 text-center" data-id="element-64">
            <a href="#pricing" onClick={handleCTAClick} className="inline-flex items-center justify-center gap-2 w-full md:w-auto px-10 py-5 min-h-[54px] bg-dark-green hover:bg-[#23472a] text-white font-poppins font-bold text-lg rounded-xl transition-all duration-300 shadow-[0_8px_20px_rgba(45,90,53,0.2)] hover:shadow-[0_12px_25px_rgba(45,90,53,0.3)] transform hover:-translate-y-1" data-id="element-65">
              → Quiero este sistema completo
            </a>
          </div>
        </SectionWrapper>
      </div>
    </section>;
}